import { HeadSection } from 'components/HeadSection';
import { useTenantConfig } from 'contexts';
import { useIdentifiedPage } from 'hooks';
import dynamic from 'next/dynamic';
import React, { useEffect } from 'react';
import { PbPageProps as PbHomeProps } from '../../page-builder';
import { DefaultHomeProps } from './DefaultHome';

const DefaultHome = dynamic(() =>
  import('./DefaultHome').then((mod) => mod.DefaultHome),
);

const PbHome = dynamic(() =>
  import('../../page-builder').then((mod) => mod.PbPage),
);

export type HomeProps = DefaultHomeProps & PbHomeProps;

export const Home: React.FC<HomeProps> = ({
  menuItems,
  pbContent,
  pbMetaData,
  pbSSRData,
  menu,
  ...defaultHomeProps
}: HomeProps) => {
  const { epicPb1887, baseDomain, canonicalDomain } = useTenantConfig();

  useIdentifiedPage('homePage');

  useEffect(() => {
    window?.scrollTo(0, 0);
  }, []);

  return (
    <>
      <HeadSection
        canonical={canonicalDomain || baseDomain}
        {...(epicPb1887 && pbMetaData
          ? {
              title: pbMetaData.metaTitle,
              description: pbMetaData.metaDescription,
              keywords: pbMetaData.metaKeywords?.toString(),
              schemaPage: pbMetaData.jsonLd,
            }
          : {})}
      />
      {epicPb1887 ? (
        <PbHome
          pbContent={pbContent}
          pbSSRData={pbSSRData}
          pbMetaData={pbMetaData}
          menu={menu}
        />
      ) : (
        <DefaultHome menuItems={menuItems} {...defaultHomeProps} />
      )}
    </>
  );
};
